<template>
    <div id="homebanner">
        <img id="homeImage" src="../../assets/images/empanadillas.jpeg">
        <img id="homeLogo" src="../../assets/images/losplatoslogo.png">
    </div>
</template>

<script>
export default {
    name: 'HomeHeader',
}
</script>

<style scoped>
    #homeLogo{
        top: 50px;
        display: block;
        width: 200px;
        position: absolute;
        margin-left: 50%;
        left: -100px;
    }
    #homeImage {
        position: relative;
        top: 0;
        left: 0;
        height: 300px;
        object-fit: cover;
        width: 100%;
    }
    #homebanner {
        position: relative;
        top: 0;
        left: 0;
        margin-bottom: 20px;
    }
    
</style>
